import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const IntegrationEcosystem = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const integrations = [
  {
    id: 1,
    name: "WhatsApp Business",
    logo: "/images/integration_whatsapp.webp",
    logoAlt: "WhatsApp green speech bubble logo with white phone icon on bright green background representing messaging platform",
    category: "Messaging",
    description: "Автоматизация общения в WhatsApp",
    status: "active"
  },
  {
    id: 2,
    name: "Instagram",
    logo: "/images/integration_instagram.webp",
    logoAlt: "Instagram gradient camera icon logo with purple pink orange colors on white background representing social media platform",
    category: "Social Media",
    description: "Управление сообщениями и комментариями",
    status: "active"
  },
  {
    id: 3,
    name: "Telegram",
    logo: "/images/integration_telegram.webp",
    logoAlt: "Telegram blue paper plane logo icon on light blue background representing instant messaging service",
    category: "Messaging",
    description: "Боты и автоматизация каналов",
    status: "active"
  },
  {
    id: 4,
    name: "Shopify",
    logo: "/images/rocket_gen_img_13fc153c7-1764426210684.webp",
    logoAlt: "Shopify green shopping bag logo with white S letter on bright green background representing ecommerce platform",
    category: "E-commerce",
    description: "Синхронизация заказов и товаров",
    status: "active"
  },
  {
    id: 5,
    name: "Stripe",
    logo: "/images/rocket_gen_img_13ae5e821-1764426211901.webp",
    logoAlt: "Stripe purple payment processing logo with diagonal stripes on white background representing online payment gateway",
    category: "Payments",
    description: "Обработка платежей онлайн",
    status: "active"
  },
  {
    id: 6,
    name: "Google Analytics",
    logo: "/images/rocket_gen_img_11c364839-1764426212287.webp",
    logoAlt: "Google Analytics orange bar chart logo icon on white background representing web analytics service",
    category: "Analytics",
    description: "Отслеживание конверсий",
    status: "active"
  },
  {
    id: 7,
    name: "AMOcrm",
    logo: "/images/rocket_gen_img_15bf7adf9-1765047965370.webp",
    logoAlt: "AMOcrm orange and blue logo representing customer relationship management system",
    category: "CRM",
    description: "Управление клиентской базой",
    status: "active"
  },
  {
    id: 8,
    name: "Bitrix",
    logo: "/images/rocket_gen_img_18a55e8e1-1765047966029.webp",
    logoAlt: "Bitrix blue square logo with white B letter representing business management platform",
    category: "CRM",
    description: "Управление клиентской базой",
    status: "active"
  },
  {
    id: 9,
    name: "Zapier",
    logo: "/images/rocket_gen_img_11fcac460-1764426211083.webp",
    logoAlt: "Zapier orange lightning bolt logo icon on white background representing automation workflow platform",
    category: "Automation",
    description: "Подключение 5000+ приложений",
    status: "coming-soon"
  }];


  const categories = ["All", "Messaging", "Social Media", "E-commerce", "Payments", "Analytics", "CRM"];

  // Filter integrations based on selected category
  const filteredIntegrations = selectedCategory === "All" ?
  integrations :
  integrations?.filter((integration) => integration?.category === selectedCategory);

  return (
    <section className="py-16 lg:py-24 bg-[#0A0E27]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-[#1E293B] rounded-full px-6 py-3 mb-6">
              <Icon name="Plug" size={20} color="#00D4FF" />
              <span className="text-sm font-medium text-[#00D4FF]">
                Экосистема интеграций
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-headline font-bold text-white mb-4">
              Подключайте любимые инструменты
            </h2>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Бесшовная интеграция с популярными платформами для создания единой экосистемы вашего бизнеса
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories?.map((category) =>
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 backdrop-blur-sm rounded-full border transition-all duration-300 text-sm font-medium ${
              selectedCategory === category ?
              'bg-[#00D4FF] text-white border-[#00D4FF]' :
              'bg-white/5 text-gray-300 border-white/10 hover:border-[#00D4FF]/50 hover:text-[#00D4FF]'}`
              }>

                {category}
              </button>
            )}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {filteredIntegrations?.map((integration, index) =>
            <div
              key={integration?.id}
              className="group bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-[#00D4FF]/50 transition-all duration-300 hover:transform hover:scale-105"
              style={{ animationDelay: `${index * 50}ms` }}>

                <div className="flex items-start justify-between mb-4">
                  <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center overflow-hidden">
                    <Image
                    src={integration?.logo}
                    alt={integration?.logoAlt}
                    className="w-full h-full object-cover" />

                  </div>
                  {integration?.status === 'active' ?
                <div className="flex items-center space-x-1 text-green-500 text-xs">
                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                      <span>Active</span>
                    </div> :

                <div className="text-xs text-gray-400 bg-white/5 px-2 py-1 rounded">
                      Soon
                    </div>
                }
                </div>

                <h3 className="text-lg font-semibold text-white mb-2">
                  {integration?.name}
                </h3>

                <p className="text-gray-400 text-sm mb-3">
                  {integration?.description}
                </p>

                <div className="flex items-center">
                  <span className="text-xs text-gray-500 bg-white/5 px-3 py-1 rounded-full">
                    {integration?.category}
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="bg-gradient-to-r from-[#00D4FF]/10 to-[#9D4EDD]/10 rounded-3xl p-8 lg:p-12 border border-[#00D4FF]/20">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl lg:text-3xl font-headline font-bold text-white mb-4">
                  Не нашли нужную интеграцию?
                </h3>
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Используйте наш REST API для создания собственных интеграций или свяжитесь с нами для разработки кастомного решения
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <button
                    onClick={() => window.open('https://wa.me/77476660065', '_blank')}
                    className="px-6 py-3 bg-gradient-to-r from-[#00D4FF] to-[#9D4EDD] text-white font-semibold rounded-xl hover:shadow-xl transition-all duration-300 flex items-center justify-center space-x-2">

                    <span>Связаться с нами</span>
                    <Icon name="MessageSquare" size={18} />
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <Icon name="Code" size={32} color="#00D4FF" className="mb-3" />
                  <h4 className="text-white font-semibold mb-1">REST API</h4>
                  <p className="text-gray-400 text-sm">Полная документация</p>
                </div>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <Icon name="Webhook" size={32} color="#9D4EDD" className="mb-3" />
                  <h4 className="text-white font-semibold mb-1">Webhooks</h4>
                  <p className="text-gray-400 text-sm">Реал-тайм события</p>
                </div>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <Icon name="Shield" size={32} color="#10B981" className="mb-3" />
                  <h4 className="text-white font-semibold mb-1">OAuth 2.0</h4>
                  <p className="text-gray-400 text-sm">Безопасная авторизация</p>
                </div>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <Icon name="Zap" size={32} color="#F59E0B" className="mb-3" />
                  <h4 className="text-white font-semibold mb-1">Rate Limits</h4>
                  <p className="text-gray-400 text-sm">До 10K запросов/мин</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default IntegrationEcosystem;